import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./helpers/base-query";
import { zoneApiInstance } from "./axios/api-instances";

const baseQuery = axiosBaseQuery(zoneApiInstance);

export const zoneApi = createApi({
  reducerPath: "zoneApi",
  baseQuery,
  endpoints: (builder) => ({
    proximityScreenZoneList: builder.query<ListProximities, void>({
      query: () => ({
        method: "GET",
        url: `/proximity_screen_zones`,
      }),
    }),
    screenZoneProximity: builder.query<ProximityDetails, { zoneId: string }>({
      query: ({ zoneId }) => ({
        method: "GET",
        url: `/proximity_screen_zones/${zoneId}`,
      }),
    }),
  }),
});

export const { useProximityScreenZoneListQuery, useScreenZoneProximityQuery } = zoneApi;

export type ListProximities = {
  screen_zone_id: "string";
  sku_bins: [
    {
      bin_id: 0;
      sku_id: 0;
    }
  ];
}[];

export type ProximityDetails = {
  proximity_id: "string";
  track_id: 0;
  time_start: "2024-06-25T15:09:41.620Z";
  time_finish: "2024-06-25T15:09:41.620Z";
  hand_id: 0;
  gondola_name: "string";
  planogram_id: 0;
  closest_bin_id: number;
  closest_bin_dist: 0;
  closest_bin_xyz_center: [0];
  closest_sku_id: 0;
  closest_sku_dist: 0;
  track_wrist_xyz_at_peak: [0];
  track_wrist_conf_at_peak: 0;
  start_score: 0;
  finish_score: 0;
  finished_at: "2024-06-25T15:09:41.620Z";
};
